import { useQuery } from '@tanstack/react-query';
import { groupInfo, type GroupInfo } from '@/services/api/endpoints';

/**
 * Espaces collaboratifs du groupe Microsoft 365 d'un espace (SharePoint, Teams).
 *
 * `enabled` est piloté par l'OUVERTURE du sous-menu « Espaces collaboratifs » :
 * la résolution passe par deux appels Graph côté serveur, on ne les déclenche pas
 * pour chaque projet affiché dans l'arbre.
 *
 * Durée de cache longue et volontaire : un site SharePoint ou une équipe Teams
 * ne change pas d'adresse. Sans cela, chaque survol du sous-menu relancerait
 * Graph.
 */
export function useGroupInfo(m365GroupId: string | null, enabled: boolean) {
  return useQuery<GroupInfo>({
    queryKey: ['group-info', m365GroupId],
    queryFn: () => groupInfo(m365GroupId!),
    enabled: enabled && Boolean(m365GroupId),
    staleTime: 30 * 60 * 1000,
    gcTime: 60 * 60 * 1000,
    retry: 1,
  });
}
